var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#333","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("circle",{"cx":"12","cy":"12","r":"9","fill":"#FFF","transform":"rotate(45 12 12)","key":0}),React.createElement("g",{"fill":"#DDD","key":1},React.createElement("path",{"d":"M12 17.657V6.343v11.314zM6.343 12h11.314H6.343z"}))]));
}

Plus.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Plus;

Plus.default = Plus;
